module.exports = __webpack_public_path__ + "83a9787d4cb6f3b7632b4ddfebf74367.wav";